import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { emptyFragment } from '../../../../EmptyFragment';
import { findLink } from '../../../../LinkyLinky';
import { Segment } from '../../Segment';
import ActionLink from './ActionLink';
import ImportLink from './ImportLink';

interface Props {
  segment: Segment;
}

/**
 * The CTA follows the segment and reuses the current add-participant and
 * new-group pages, gated by the links those pages need.
 */
function PrimaryAction({ segment }: Props) {
  switch (segment) {
    case 'participants':
      return (
        <div className="flex flex-shrink-0 items-center gap-2">
          <ImportLink />
          {findLink('v2-create-participant', currentUserStore.links)
            .map(() => (
              <ActionLink
                to="/people/add_participant"
                label="Add participant"
                intercomTarget="people-v2-add-participant-button"
              />
            ))
            .getOrElse(emptyFragment)}
        </div>
      );
    case 'groups':
      return findLink('user-groups-new', currentUserStore.links)
        .map(() => (
          <ActionLink
            to="/people/groups/new"
            label="New group"
            intercomTarget="people-v2-new-group-button"
          />
        ))
        .getOrElse(emptyFragment);
    default:
      return assertNever(segment);
  }
}

export default observer(PrimaryAction);
